import React, { useCallback } from 'react';
import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';
import { Tooltip } from '@hotjar/webapp/components/Tooltip';

import { SectionTooltipContent } from './SectionTooltipContent';
import { useRealTimeStore } from '../../store/realTimeStore';

export const StyledTooltip = styled(Tooltip)`
  pointer-events: none;
  background-color: ${tokens.color.neutral_700};

  padding: 0;
  border-radius: ${tokens.spacer.x0};
`;

const AnchorDiv = styled.div`
  position: absolute;
  left: 0;
`;

interface Props {
  isDragging: boolean;
  width: number;
  duration: number;
  id?: string;
}

export const SectionTooltip = ({ isDragging, width, duration, id }: Props): JSX.Element => {
  const xPositionInPx = useRealTimeStore(
    useCallback(
      (state) =>
        isDragging
          ? (state.draggedTime / duration) * width
          : (state.hoveredTime / duration) * width,
      [isDragging, duration, width],
    ),
  );

  return (
    <StyledTooltip
      content={<SectionTooltipContent id={id} isDragging={isDragging} />}
      visible
      arrow={false}
      offset={[0, 20]}
    >
      <AnchorDiv
        draggable="false"
        style={{
          transform: `translateX(${xPositionInPx}px)`,
        }}
      />
    </StyledTooltip>
  );
};
